import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField as TextFieldMUI,
  Grid,
  Popper,
  Typography,
} from "@mui/material";
import { fieldToTextField } from "formik-mui";
import { useSelector, useDispatch } from "react-redux";
import { Autocomplete } from "@mui/lab";

import { addFavorite } from "../store/ducks/duckFavorites";
import { useUser } from "../auth/UserProvider";

import { BorderLinearProgress } from "./LoadingComponent";

const stylesPopper = () => ({
  popper: {
    maxWidth: "fit-content",
  },
});

const PopperMy = function (props) {
  return <Popper {...props} placement="bottom-start" style={stylesPopper.popper} />;
};

export const FormikAutocompleteLayouts = ({ textFieldProps, ...props }) => {
  const loading = useSelector((state) => state.favorites.loadingFavorites);
  const paths = useSelector((state) => state.sidebar.paths);

  const {
    form: { setTouched, setFieldValue },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  return (
    <Autocomplete
      {...props}
      {...field}
      PopperComponent={PopperMy}
      defaultValue={""}
      getOptionLabel={(x) => x.name ?? ""}
      inputMode={"search"}
      loading={loading}
      renderInput={(props) => (
        <TextFieldMUI
          {...props}
          {...textFieldProps}
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {props.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
      renderOption={(value, _state) => (
        <Typography>
          {value.name}
          {value?.layoutId && paths[value.layoutId] && (
            <Typography color="textSecondary">{paths[value.layoutId]}</Typography>
          )}
        </Typography>
      )}
      onBlur={(e) => {
        e.preventDefault();
        setTouched({ [name]: true });
      }}
      onChange={(_, valueOnChange) => setFieldValue(name, valueOnChange)}
    />
  );
};

const FavoriteForm = (props) => {
  const { handleClose, open } = props;
  const layoutsWithoutFavorites = useSelector((state) => state.favorites.layouts);
  const paths = useSelector((state) => state.sidebar?.paths);
  const { networkUser } = useUser();
  const dispatch = useDispatch();
  const [layouts, setLayouts] = useState([]);

  useEffect(() => {
    if (paths) {
      let layoutsWithPermissions = layoutsWithoutFavorites?.filter((x) =>
        paths.hasOwnProperty(x.layoutId),
      );

      setLayouts(layoutsWithPermissions ?? []);
    }
  }, [layoutsWithoutFavorites, paths]);

  return (
    <>
      <Formik
        initialValues={{ layout: { layoutId: 0 } }}
        validate={(values) => {
          let errors = {};

          if (!values.layout) {
            errors.layout = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          let favorite = {
            layoutId: values.layout.layoutId,
            networkUser,
            id: 0,
          };

          return dispatch(
            addFavorite(favorite, () => {
              setSubmitting(false);
            }),
          ).then(() => handleClose());
        }}
      >
        {({ submitForm, isSubmitting, _values }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="xs"
              open={open}
              scroll={"paper"}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">Add</DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  <Field
                    component={FormikAutocompleteLayouts}
                    margin="dense"
                    name="layout"
                    options={layouts}
                    style={{ width: "100%", height: "100%" }}
                    textFieldProps={{
                      fullWidth: true,
                      margin: "dense",
                      variant: "outlined",
                      label: "Layout",
                    }}
                    variant="outlined"
                  />
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={handleClose}>
                  Close
                </Button>
                <Button color="primary" variant="contained" onClick={submitForm}>
                  Add
                </Button>
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FavoriteForm;
